import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { shippingAddressStyles } from "@insite/content-library/Widgets/CheckoutShipping/ShippingAddress";
import getColor from "@insite/mobius/utilities/getColor";

import { css } from "styled-components";

shippingAddressStyles.shipToSelector = mergeToNew(shippingAddressStyles.shipToSelector, {
    customerSelectorToolbar: {
        searchTextField: {
            cssOverrides: {
                formInputWrapper: css`
                    > input {
                        padding-right: 35px !important;
                    }
                `,
            },
        },
    },
    customerSelector: {
        customerCard: {
            container: {
                css: css`
                    padding: 1rem 0;
                    border-bottom: 1px solid ${getColor("common.border")};
                    max-width: 100% !important;
                `,
            },
        },
    },
});
